// Core Modules
import React, { Component } from 'react';
// Components
import Sidebar from '../../components/Sidebar/Sidebar';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
// Styles
import '../assets/css/material-dashboard.css';
// Depandancy Modules
import * as firebase from 'firebase/app';
import 'firebase/auth';
import "firebase/storage";
import swal from 'sweetalert';
import RingLoader from "react-spinners/RingLoader";
import axios from 'axios';

class IndividualExams extends Component {
    
    state = { 
        examId: this.props.match.params.id,
        isLoading: true,
        displayContent: null,
        file: null,
        examData: null,
        percentage: '0',
        isStarted: 'none',
        color: 'green'
    }

    componentDidMount = () => {
        if (!!document.getElementsByClassName('nav-open')[0]) {
            document.getElementsByClassName('nav-open')[0].classList.remove('nav-open');
        }
        let cachedData = sessionStorage.getItem('auth_data');
        if (!!cachedData) {
            let authData = JSON.parse(cachedData);
            let postUrl = 'https://us-central1-insightplus-mpm.cloudfunctions.net/app/web/v1/getpaper';
            axios.post(postUrl, {
                username: authData.username,
                password: authData.password,
                examid: this.state.examId
            }).then((response) => {
                if (response.status === 200) {
                    this.setState({examData: response.data.data}, () => {
                        let tempComp =  <React.Fragment>
                                            <h3 style={{fontSize: '30px'}}>{this.state.examData.title}</h3>
                                            <table className="table">
                                                <tbody>
                                                    <tr>
                                                        <th>Starting Time</th>
                                                        <td>{new Date(this.state.examData.initialTime).toLocaleString()}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Ending Time</th>
                                                        <td>{new Date(this.state.examData.finalTime).toLocaleString()}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Question Paper</th>
                                                        <td>
                                                            <a download="exam.pdf" target="_blank" rel="noopener noreferrer" href={this.state.examData.queUrl} className="btn btn-info">Download</a>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>Status</th>
                                                        <td>
                                                            {this.state.examData.submitted ? 'SUBMITTED' : 'NOT SUBMITTED'}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            {
                                                this.state.examData.submitted ? null : 
                                                    <div className="row" style={{marginTop: '20px', marginBottom: '20px'}}>
                                                        <div className="col-md-6">
                                                            <label htmlFor="ipFile">Select Answer File *</label>
                                                            <input
                                                                type="file" 
                                                                className="form-control-file" 
                                                                id="ipFile" 
                                                                onChange={this.fileChangleHandler}/>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <button className="btn" onClick={this.examSubmitHandler}>SUBMIT EXAM</button>
                                                        </div>
                                                    </div>
                                            }
                                        </React.Fragment>;
                        this.setState({isLoading: false, displayContent: tempComp});
                    });
                }else if (response.status === 201) { 
                    let tempComp =  <React.Fragment>
                                        <h1 style={{color: 'black', fontSize: '26px'}}>{response.data.message}</h1>
                                    </React.Fragment>;
                    this.setState({displayContent: tempComp, isLoading: false});
                }else if (response.status === 500) { 
                    let tempComp =  <React.Fragment>
                                        <h1 style={{color: 'black', fontSize: '26px'}}>{response.data.message}</h1>
                                    </React.Fragment>;
                    this.setState({displayContent: tempComp, isLoading: false});
                }else {
                    let tempComp =  <React.Fragment>
                                        <h1 style={{color: 'black', fontSize: '26px'}}>Unknown server error</h1>
                                    </React.Fragment>;
                    this.setState({displayContent: tempComp, isLoading: false});
                }              
            }).catch((err) => {
                this.setState({isLoading: false}, () => {
                    swal("Error", err.toString(), "error");
                });
            });
        } else {
            swal("", "Session Expired", "warning").then(() => {
                firebase.auth().signOut()
                .then(() => {
                    sessionStorage.setItem('auth_data', '');
                    window.location.pathname = '/';
                });
            });
        }
    }

    fileChangleHandler = (event) => {
        if (event.target.files[0]) {
            this.setState({file: event.target.files[0]});
        }
    }

    examSubmitHandler = () => {
        let userId = firebase.auth().currentUser.uid;
        if (!!this.state.file) {
            if (this.state.file.type.split('/')[1] === 'pdf') {
                let cachedData = sessionStorage.getItem('auth_data');
                if (!!cachedData) {
                    let authData = JSON.parse(cachedData);
                    console.log(authData.username, authData.password, this.state);
                    this.setState({isStarted: 'block'});
                    let uploadTask = firebase.storage().ref(`/exams/${this.state.examData.subject}/${this.state.examData.bucket}/submissions/${userId}/`+this.state.file.name.split(' ').join("")).put(this.state.file, {type: this.state.file.type, size: this.state.file.size});
                    uploadTask.on('state_changed', (snapshot) => {
                        let progressPercent = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                        progressPercent = progressPercent.toFixed(2);
                        this.setState({percentage: progressPercent});
                    }, (error) => {
                        console.log(error);
                        this.setState({color: 'red'});
                    }, () => {
                        uploadTask.snapshot.ref.getDownloadURL().then((url) => {
                            console.log("Now you can call submit api from here");
                            console.log(url);
                            let postUrl = 'https://us-central1-insightplus-mpm.cloudfunctions.net/app/web/v1/submitexam';
                            axios.post(postUrl, {
                                username: authData.username,
                                password: authData.password,
                                examid: this.state.examId,
                                ansUrl: url
                            }).then((response) => {
                                if (response.status === 200) {
                                    swal("", response.data.message, "success").then(() => {
                                        window.location.pathname = '/exams';
                                    });
                                }else {
                                    swal("", response.data.message, "info").then(() => {
                                        window.location.pathname = '/exams';
                                    });
                                }
                            }).catch((err) => {
                                this.setState({isStarted: 'none'}, () => {
                                    swal("Error", err.toString(), "error");
                                });
                            });
                        });
                    });
                } else {
                    swal("", "Session Expired", "warning").then(() => {
                        firebase.auth().signOut()
                        .then(() => {
                            sessionStorage.setItem('auth_data', '');
                            window.location.pathname = '/';
                        });
                    });
                }
            } else {
                swal("", "Select a pdf file", "info");
            }
        } else {
            swal("", "Select a pdf file", "info");
        }
    }
    
    render() { 
        return ( 
            <div className="wrapper ">
                <Sidebar />
                <div className="main-panel">
                    <Navbar />
                    <div className="content">
                        <div className="container-fluid ind-std">
                            <RingLoader
                                css={{display: 'block', margin: '25vh auto',borderColor: 'red'}}
                                size={150}
                                color={"#262222"}
                                loading={this.state.isLoading} />
                            {
                                this.state.displayContent
                            } 
                            <div className="row">
                                <div style={{display: this.state.isStarted, width: '90%', backgroundColor: '#fff', height: '30px', margin: '0 auto 20px', borderRadius: '15px', overflow: 'hidden', padding: '3px'}}>
                                    <div style={{width: this.state.percentage+'%', height: '100%', backgroundColor: this.state.color, borderRadius: '15px'}}>
                                        <div style={{width: '100%', textAlign: 'right', paddingRight: '10px', color: 'white', fontWeight: 'bold'}}>{this.state.percentage} %</div>
                                    </div>
                                </div>
                            </div>                           
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }
}
 
export default IndividualExams;